import { Injectable } from '@angular/core';
import { CustomOptions, ThemeOptions, Stt } from './customOptions.model';
import invert from 'lodash-es/invert';
import { parseStt } from './transformers/parse.stt';

@Injectable()
export class CustomOptionsService {
  constructor() {}

  public extractCustomInfo(values: any): CustomOptions {
    let stt: Stt;
    let theme: ThemeOptions;

    const avatarSchema = values.definitions.basicAvatar;

    if (avatarSchema.properties.stt) {
      stt = this.extractSttOptions(values.definitions.stt);
    }

    if (avatarSchema.properties.theme) {
      theme = this.extractThemeOptions(values.definitions.theme);
    }

    return { stt, theme };
  }

  private extractSttOptions(sttDef: any): Stt {
    return parseStt(sttDef);
  }

  /**
   * Extract theme options from the json schema
   *
   * @param themeDef - part of the json schema responsible for themes
   */
  private extractThemeOptions(themeDef: any): ThemeOptions {
    const title = themeDef.title;
    const ids = invert(themeDef.meta.description.id);
    return {
      title,
      ids,
    };
  }
}
